// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2a47f027&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/features/courses/pages/settings/generalSettings.vue
// module id = 1025
// module chunks = 61